import React from "react";
import MainSkeleton from "./MainSkeleton";
import SidebarSkeleton from "./SidebarSkeleton";

const ProjectDetailSkeleton = () => {
  return (
    <div className="">
      <MainSkeleton
        classes={"w-full h-full sm:h-[400px] md:h-[450px] lg:h-[500px]"}
      />
      <div className="flex flex-col lg:flex-row gap-3 justify-between">
        <main className="lg:w-[70%] flex-grow">
          <div className="mt-8 sm:mt-10 md:mt-16">
            <MainSkeleton classes={"h-[22px] w-[200px]"} />
            <MainSkeleton classes={"h-[40px] w-full mt-4"} />
          </div>
          <div className="mt-12 sm:mt-16 md:mt-20">
            <div className="mb-6 sm:mb-8">
              <MainSkeleton classes={"h-[32px] w-[100px]"} />
              <div className="mt-4">
                <MainSkeleton classes={"h-[22px] w-full"} />
                <MainSkeleton classes={"h-[22px] w-full"} />
              </div>
            </div>
            <div className="mb-6 sm:mb-8">
              <MainSkeleton classes={"h-[32px] w-[100px]"} />
              <div className="mt-4">
                <MainSkeleton classes={"h-[22px] w-full"} />
                <MainSkeleton classes={"h-[22px] w-full"} />
                <MainSkeleton classes={"h-[22px] w-full"} />
              </div>
            </div>
            <div className="mb-6 sm:mb-8">
              <MainSkeleton classes={"h-[32px] w-[100px]"} />
              <div className="mt-4">
                <div className="mb-4">
                  <MainSkeleton classes={"h-[25px] w-[100px]"} />
                </div>
                <MainSkeleton classes={"h-[22px] w-[200px]"} />
                <MainSkeleton classes={"h-[22px] w-[200px]"} />
                <MainSkeleton classes={"h-[22px] w-[200px]"} />
              </div>
              <div className="mt-4">
                <div className="mb-4">
                  <MainSkeleton classes={"h-[25px] w-[100px]"} />
                </div>
                <MainSkeleton classes={"h-[22px] w-[200px]"} />
                <MainSkeleton classes={"h-[22px] w-[200px]"} />
                <MainSkeleton classes={"h-[22px] w-[200px]"} />
              </div>
            </div>
          </div>
        </main>
        <div className="mt-12 lg:mt-0 lg:px-6 lg:w-fit">
          <SidebarSkeleton/>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailSkeleton;
